(ns io.daskul.webapp.widgets.dashboard.subs
  "Dashboard subscriptions — sections data, loading state, and date range."
  (:require
   [re-frame.core :as rf]))

(rf/reg-sub
 ::sections
 (fn [db _]
   (get-in db [:dashboard :sections])))

(rf/reg-sub
 ::loading?
 (fn [db _]
   (get-in db [:dashboard :loading?])))

(rf/reg-sub
 ::error
 (fn [db _]
   (get-in db [:dashboard :error])))

(rf/reg-sub
 ::date-range
 (fn [db _]
   (get-in db [:dashboard :date-range])))
